/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discreet_ShippingInputs */

const en_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discreet Shipping`)
};

const th_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดส่งแบบไม่ระบุชื่อ`)
};

const ja_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`匿名配送`)
};

const fr_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison discrète`)
};

const es_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envío discreto`)
};

const ru_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анонимная доставка`)
};

const zh_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私包装配送`)
};

const vi_discreet_shipping = /** @type {(inputs: Discreet_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hàng kín đáo`)
};

/**
* | output |
* | --- |
* | "Discreet Shipping" |
*
* @param {Discreet_ShippingInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const discreet_shipping = /** @type {((inputs?: Discreet_ShippingInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discreet_ShippingInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_discreet_shipping(inputs)
	if (locale === "ja") return ja_discreet_shipping(inputs)
	if (locale === "fr") return fr_discreet_shipping(inputs)
	if (locale === "es") return es_discreet_shipping(inputs)
	if (locale === "ru") return ru_discreet_shipping(inputs)
	if (locale === "zh") return zh_discreet_shipping(inputs)
	if (locale === "vi") return vi_discreet_shipping(inputs)
	return en_discreet_shipping(inputs)
});